import { ref, inject, computed, unref } from 'vue';
import '../../tokens/index2.mjs';
import '../../utils/index2.mjs';
import '../../constants/index2.mjs';
import { useProp } from '../use-prop/index2.mjs';
import { useGlobalConfig } from '../use-global-config/index2.mjs';
import { buildProp } from '../../utils/vue/props/runtime2.mjs';
import { componentSizes } from '../../constants/size2.mjs';
import { formContextKey, formItemContextKey } from '../../tokens/form2.mjs';

const useSizeProp = buildProp({
  type: String,
  values: componentSizes,
  required: false
});
const useSize = (fallback, ignore = {}) => {
  const emptyRef = ref(void 0);
  const size = ignore.prop ? emptyRef : useProp("size");
  const globalConfig = ignore.global ? emptyRef : useGlobalConfig("size");
  const form = ignore.form ? { size: void 0 } : inject(formContextKey, void 0);
  const formItem = ignore.formItem ? { size: void 0 } : inject(formItemContextKey, void 0);
  return computed(() => size.value || unref(fallback) || (formItem == null ? void 0 : formItem.size) || (form == null ? void 0 : form.size) || globalConfig.value || "");
};
const useDisabled = (fallback) => {
  const disabled = useProp("disabled");
  const form = inject(formContextKey, void 0);
  return computed(() => disabled.value || unref(fallback) || (form == null ? void 0 : form.disabled) || false);
};

export { useDisabled, useSize, useSizeProp };
//# sourceMappingURL=index2.mjs.map
